import { WarriorType, TableExperienceType, ThingType, CombatType } from '../lib/types';

import { THING_TYPES, THING_ACTIONS } from '../lib/constants';

import {
  reset,
  updateThingStability,
  getWarriorThing,
  applyThing,
  isDressed,
  thingCanBeApplied,
  addMoney,
} from './warriorUtils';

import { getTeam } from './combatUtils';

import { getDuration as getDurationBase, getByValue } from './utils';

export function getThing(things: ThingType[], id: string): ThingType {
  return getByValue(things, id);
}

export function thingHasAction(thing: ThingType): boolean {
  return Boolean(thing.action);
}

export function thingApplyAction(
  warrior: WarriorType,
  combat: CombatType | undefined | null,
  warriorThingId: string,
  initData: {
    tableExperience: TableExperienceType[];
    things: ThingType[];
  },
) {
  const warriorThing = getWarriorThing(warrior, warriorThingId);
  if (!warriorThing) return false;
  const thing = getThing(initData.things, warriorThing.thing);
  if (!thingHasAction(thing) || !thingCanBeApplied(warrior, thing)) return false;

  if (combat && !isDressed(warriorThing)) return false;

  switch (thing.action) {
    case THING_ACTIONS.RESETS_STATS:
      reset(warrior, initData.tableExperience);
      break;
    case THING_ACTIONS.PREVENT_ATTACK:
    case THING_ACTIONS.INCREASE: {
      applyThing(warrior, warriorThing, initData.things);
      break;
    } 
    case THING_ACTIONS.ADD_MONEY: {
      const { money } = thing;
      addMoney(warrior, Number(money));
      break;
    }
    default:
  }

  updateThingStability(warrior, warriorThingId, 1, true);

  if (combat) {
    combat.logs.push({
      created: Date.now(),
      thing: thing.id,
      isThingApplied: true,
      warrior: { team: getTeam(combat, warrior), warrior: warrior.id },
    });
  }

  return undefined;
}

export function isJewelry(thing: ThingType): boolean {
  return [THING_TYPES.RING, THING_TYPES.AMULET].includes(thing.type);
}

export function isScroll(thing: ThingType): boolean {
  return THING_TYPES.SCROLL === thing.type;
}

export function isElixir(thing: ThingType): boolean {
  return THING_TYPES.ELIXIR === thing.type;
}

export function isDressable(thing: Partial<ThingType>): boolean {
  return !(isScroll(thing as ThingType) || isElixir(thing as ThingType));
}

export function isArm(thing: Partial<ThingType>, shieldInclude?: boolean): boolean {
  return (
    [THING_TYPES.SWORD, THING_TYPES.AXE, THING_TYPES.CLUBS, THING_TYPES.KNIFE].includes(
      thing.type as string,
    ) || (shieldInclude ? thing.type === THING_TYPES.SHIELD : false)
  );
}

export function getDuration(endDate: number, t: Function) {
  const duration = getDurationBase(endDate, 'asSeconds');

  return duration < 60 ? `${duration} ${t('sec')}` : `${Math.ceil(duration / 60)} ${t('min')}`;
}
